import { Model as e } from "../../../../model.js";
class p extends e {
  constructor(o) {
    super(), this.dropOff = o.dropOff;
  }
}
export {
  p as ShopSessionDeliveryModel
};
//# sourceMappingURL=delivery.model.js.map
